import { Injectable } from '@angular/core';

export function initializeGuid(guidService: UidService): () => void {
  return () => guidService.getGuid();
}


@Injectable({
  providedIn: 'root'
})
export class UidService {

  private guidKey = 'UID';
  private guid: string;

  constructor() {
    const storedGuid = sessionStorage.getItem("UID");
    if (storedGuid) {
      this.guid = storedGuid;
    } else {
      this.guid = this.generateGuid();
      sessionStorage.setItem(this.guidKey, this.guid);
    }
  }

  private generateGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  getGuid(): string {
    return this.guid;
  }
}
